import { render, staticRenderFns } from "./WorkerAssignment.vue?vue&type=template&id=741cd26c&scoped=true&"
import script from "./WorkerAssignment.vue?vue&type=script&lang=js&"
export * from "./WorkerAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741cd26c",
  null
  
)

export default component.exports